import React from 'react'
import styled from 'styled-components/macro'

import SidebarLayout from '../templates/SidebarLayout'
import Header from '../components/organisms/Header'
import { Text } from '../components/atoms/Typography'
import LoggedOutFooter from '../components/organisms/Footer/LoggedOutFooter'
import RecoverPasswordForm from '../components/organisms/Forms/RecoverPasswordForm'

export default function RecoverPassword() {
  return (
    <SidebarLayout
      hideSidebar
      smallWrapper
      HeaderComp={
        <Header
          loggedOut
          title="Recupera password"
          subtitle="Inserisci la tua mail per recuperare la password."
        />
      }
      FooterComp={<LoggedOutFooter />}
    >
      <Article>
        <RecoverPasswordForm />

        <Text>
          <p>
            Se hai dimenticato la tua password, inserisci la tua mail qui e se
            sei già un utente, riceverai una mail per resettarla.
          </p>
        </Text>
      </Article>
    </SidebarLayout>
  )
}

const Article = styled.article`
  display: flex;

  form {
    width: 40%;
    max-width: 320px;
    margin-right: 90px;
  }
  section {
    flex: 1;
  }
`
